import Actions from 'actions';

export const initialState = Object.freeze({});

function info(state = initialState, { type, data }) {
  switch (type) {
    case Actions.FETCH_VIDEO_SUCCESS:
      return data;
    case Actions.FETCH_VIDEO_REQUEST:
    case Actions.SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}

export default info;
